//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["part_type","part_number","part_revision","part_file_type","part_file_name"],"CreatePartSpec",{},5,0],[[],"NewDatabaseAttributeManager",{R_:{attribute_manager:"PDM.DatabaseAttributeManager"}},0,0],[[],"CreatePartCreationObject",{R_:{creation_object:"PDM.PartCreationObject"}},0,0],[[],"NewAlternateIdManager",{R_:{alternate_id_manager:"PDM.AlternateIdManager"}},0,0],[["part_type"],"AssignPartNumber",{R_:{part_number:''}},1,0],[[],"AssignPartRevision",{R_:{part_revision:''}},0,0],[["part_file_type"],"AssignPartFileName",{R_:{part_file_name:''}},1,0],[["old_part_number","part_type"],"AssignPartNumber1",{R_:{part_info:''}},2,0],[["overload"],"AssignPartRevision1",{R_:{part_info:''}},1,0],[["part_number","part_revision","part_file_name_type","old_part_file_name"],"AssignPartFileName1",{R_:{part_info:''}},4,0],[["part_number"],"SetAssignPartNumber",{},1,0],[["part_type"],"SetAssignPartType",{},1,0],[["operation"],"SetContextOperation",{},1,0]],[]];
SPLM.PDM.PartBuilder = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.PartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.PartBuilder.PartNumberData = class{
    constructor(part_name,part_name_modifiable,part_description,part_description_modifiable,part_number,part_number_modifiable){
        this.part_name=part_name;this.part_name_modifiable=part_name_modifiable;this.part_description=part_description;this.part_description_modifiable=part_description_modifiable;this.part_number=part_number;this.part_number_modifiable=part_number_modifiable;}
    get PartName(){return this.part_name}
    set PartName(val){this.part_name = val}
    get PartNameModifiable(){return this.part_name_modifiable}
    set PartNameModifiable(val){this.part_name_modifiable = val}
    get PartDescription(){return this.part_description}
    set PartDescription(val){this.part_description = val}
    get PartDescriptionModifiable(){return this.part_description_modifiable}
    set PartDescriptionModifiable(val){this.part_description_modifiable = val}
    get PartNumber(){return this.part_number}
    set PartNumber(val){this.part_number = val}
    get PartNumberModifiable(){return this.part_number_modifiable}
    set PartNumberModifiable(val){this.part_number_modifiable = val}
};

SPLM.PDM.PartBuilder.PartRevisionData = class{
    constructor(part_revision,part_revision_modifiable){
        this.part_revision=part_revision;this.part_revision_modifiable=part_revision_modifiable;}
    get PartRevision(){return this.part_revision}
    set PartRevision(val){this.part_revision = val}
    get PartRevisionModifiable(){return this.part_revision_modifiable}
    set PartRevisionModifiable(val){this.part_revision_modifiable = val}
};

SPLM.PDM.PartBuilder.PartFileNameData = class{
    constructor(part_file_name,part_file_name_modifiable){
        this.part_file_name=part_file_name;this.part_file_name_modifiable=part_file_name_modifiable;}
    get PartFileName(){return this.part_file_name}
    set PartFileName(val){this.part_file_name = val}
    get PartFileNameModifiable(){return this.part_file_name_modifiable}
    set PartFileNameModifiable(val){this.part_file_name_modifiable = val}
};

SPLM.PDM.PartBuilder.Operation = Object.freeze({
    "ExportPartNew" : "ExportPartNew", "AssemblyDiagram" : "AssemblyDiagram", "AssemblyCreateNewComponent" : "AssemblyCreateNewComponent", "Default" : "Default"});

export default SPLM;